import React from 'react';
import { connect } from 'react-redux';
import { withProps, compose } from 'recompose';
import SummaryList from 'components/general/SummaryList/SummaryList';
import MediaSkeleton from 'components/general/Media/MediaSkeleton';
import ArticleSummary from 'containers/ArticleSummary';
import { selectors } from './../ducks/globalArticles.duck';

const GlobalArticlesList = compose(
  withProps({
    renderItem: props => (
      <ArticleSummary
        {...props}
        small
      />
    ),
    renderSkeletonItem: () => (
      <MediaSkeleton horizontal image={false} />
    ),
  }),
  connect(state => ({
    items: selectors.inOrder(state),
    loading: selectors.loading(state),
  })),
)(SummaryList);

export default GlobalArticlesList;

